import { combineReducers } from "redux";

import { AUTH_API_LOGOUT } from "./user/actionTypes";
import accounts from "./accounts/reducer";
import metadata from "./metadata/reducer";
import audioFile from "./audioFile/reducer";
import client from "./client/reducer";
import user from "./user/reducer";
import metadataForm from "./metadatapopup/metadataFormSlice";
import localStorage from "redux-persist/lib/storage";

const appReducer = combineReducers({
  accounts,
  metadata,
  audioFile,
  client,
  user,
  metadataForm,
});

const rootReducer = (state, action) => {
  if (action.type === AUTH_API_LOGOUT) {
    localStorage.removeItem("persist:aoedeRoot");
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
